export default {
    nav: {
        subject: "条款与政策"
    }
}
